import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { STOCK_RESERVATION, StockReservationStatusValues, STOCK_RESERVATION_STATUS_LABELS, } from '../types/stock-reservation.js';
/**
 * Descriptor for StockReservation — read via `/pg/v1`.
 * Mutated only by `/stock/reservations*` (request 0105 / 0107).
 * Lot-agnostic: no `lotId` (spec §15).
 */
export const stockReservationDescriptor = {
    name: STOCK_RESERVATION,
    label: 'Reserva de Estoque',
    domain: 'stock',
    collectionPath: 'org/{orgId}/stock-reservation',
    pathPatternKeys: { orgId: 'string' },
    version: 2,
    description: 'Soft hold on available quantity at a stock location (lot-agnostic)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'readonly',
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'productId', label: 'Produto', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: true },
        { name: 'quantity', label: 'Quantidade', type: 'number', display: 'quantity', required: true },
        {
            name: 'status',
            label: 'Status',
            type: 'enum',
            required: true,
            enumValues: [...StockReservationStatusValues],
            enumLabels: STOCK_RESERVATION_STATUS_LABELS,
        },
        { name: 'sourceType', label: 'Tipo origem', type: 'string', required: false },
        { name: 'sourceId', label: 'Id origem', type: 'string', required: false },
        { name: 'idempotencyKey', label: 'Idempotência', type: 'string', required: true },
        { name: 'createdBy', label: 'Criado por', type: 'string', required: false },
        { name: 'createdAt', label: 'Criado em', type: 'date', display: 'datetime', required: false },
        { name: 'resolvedAt', label: 'Resolvido em', type: 'date', display: 'datetime', required: false },
        { name: 'resolvedBy', label: 'Resolvido por', type: 'string', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=stock-reservation.descriptor.js.map